// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardScreen_container__3guAJ"};